module.exports = __webpack_public_path__ + "static/media/distributiveOr1.d7bb3eee.JPG";